import { Directive, Input, Output, EventEmitter, OnDestroy, OnInit, AfterViewInit, ElementRef} from '@angular/core';
import {Subject} from 'rxjs';
import { delay, filter } from 'rxjs/operators';
@Directive({
  selector: '[visibility]',
})
export class VisibleObserverDirective
  implements OnDestroy, OnInit, AfterViewInit {
  @Input() debounceTime = 25;
  @Input() threshold = 1;
  @Input() order = 1;

  @Output() onVisible = new EventEmitter<HTMLElement>();

  private observer: IntersectionObserver | undefined;
  private subject$ = new Subject<{
    entry: IntersectionObserverEntry;
    observer: IntersectionObserver;
  }>();

  constructor(private element: ElementRef) {

  }

  ngOnInit() {
    this.createObserver();
    this.element.nativeElement.style.opacity = 0
    this.element.nativeElement.style.transition = `all 500ms ${this.order * 50}ms ease-in-out`
    this.element.nativeElement.style.transform = "translateY(100px)"
  }

  ngAfterViewInit() {
    this.startObservingElements();
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = undefined;
    }

    this.subject$.next();
    this.subject$.complete();
  }

  private isVisible(element: HTMLElement) {
    return new Promise(resolve => {
      const observer = new IntersectionObserver(([entry]) => {
        resolve(entry.intersectionRatio === 1);
        observer.disconnect();
      });

      observer.observe(element);
    });
  }

  private createObserver() {
    const options = {
      rootMargin: '0px',
      threshold: this.threshold,
    };

    const isIntersecting = (entry: IntersectionObserverEntry) =>
      entry.isIntersecting || entry.intersectionRatio > 0;

    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (isIntersecting(entry)) {
          
          this.element.nativeElement.style.opacity = 1
          this.element.nativeElement.style.transform = "translateY(0)"
          this.subject$.next({ entry, observer });
 
        }
      });
    }, options);
  }

  private startObservingElements() {
    if (!this.observer) {
      return;
    }

    this.observer.observe(this.element.nativeElement);

    this.subject$
      .pipe(delay(this.debounceTime), filter(Boolean))
      .subscribe(async ({ entry, observer }) => {
        const target = entry.target as HTMLElement;
        const isStillVisible = await this.isVisible(target);

        if (isStillVisible) {
          this.onVisible.emit(target);
          observer.unobserve(target);
        }
      });
  }
}